import React from 'react'
import AgentsTable from '../components/agents page/agents table/AgentsTable'

const AgentsTablePage = () => {
  return (
    <div>
      <AgentsTable/>
    </div>
  )
}

export default AgentsTablePage
 